import { ICategoryListItem } from '../../../services/api/client/index';
import { IAction, KEEP_THE_SAME, StateStatus } from 'redux/utils/common';
import {
  IAgent,
  IClientListItem,
  IRole,
  ICustomersMiniProfileData,
} from 'services/api/client';
import * as Types from './types';
import { LanguagesEnum } from 'constants/languages';
import { ICategoryListOutput } from 'services/api/category';
import * as ProductService from 'services/api/product';
import { IProductListOutput } from 'services/api/product';
import {
  FiltersSelectionInitialValue,
  IFiltersSelection,
} from 'components/molecules/ProductFilter/store/reducer';
import { PropertyFilterType } from 'components/molecules/ProductFilter/configuration';
import { isObjectNullish } from 'utils/objects';
import { IDataItems } from 'services/api/category';
export interface IState {
  products: {
    status: StateStatus | null;
    data: IProductListOutput | null;
  };
  filtersSelection: IFiltersSelection;
  published: number;
  category: {
    status: StateStatus | null;
    data: Array<IDataItems>;
  };
  insertProductFilter: {
    status: StateStatus | null;
  };
  saveSearch: {
    status: StateStatus | null;
  };
}

export const initialState: IState = {
  products: {
    status: null,
    data: null,
  },
  filtersSelection: FiltersSelectionInitialValue,
  published: 2,
  category: {
    status: null,
    data: [],
  },
  insertProductFilter: {
    status: null,
  },
  saveSearch: {
    status: null,
  },
};

const ReportingListReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_PRODUCT_LIST:
      return {
        ...state,
        products: {
          ...state.products,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.products.data
              : action.data.page === 0
              ? action.data.data
              : {
                  paging: action.data?.data?.paging,
                  items: [
                    ...(state.products.data?.items
                      ? state.products.data?.items
                      : []),
                    ...(action.data.data?.items ? action.data.data?.items : []),
                  ],
                },
        },
        // ...(action.data.data && action.data.data.filters
        //   ? {
        //       filtersSelection: {
        //         ...FiltersSelectionInitialValue,
        //         fetch: false,
        //         [PropertyFilterType.PropertyType]: {
        //           ...state.filtersSelection[PropertyFilterType.PropertyType],
        //           isChecked: !isObjectNullish({
        //             ...state.filtersSelection[PropertyFilterType.PropertyType]
        //               .data,
        //             ...action.data.data.filters[
        //               PropertyFilterType.PropertyType
        //             ],
        //           }),
        //           data: {
        //             ...state.filtersSelection[PropertyFilterType.PropertyType]
        //               .data,
        //             ...action.data.data.filters[
        //               PropertyFilterType.PropertyType
        //             ],
        //           },
        //         },
        //         [PropertyFilterType.Location]: {
        //           ...state.filtersSelection[PropertyFilterType.Location],
        //           isChecked: !isObjectNullish({
        //             ...state.filtersSelection[PropertyFilterType.Location].data,
        //             ...action.data.data.filters[PropertyFilterType.Location],
        //           }),
        //           data: {
        //             ...state.filtersSelection[PropertyFilterType.Location].data,
        //             ...action.data.data.filters[PropertyFilterType.Location],
        //           },
        //         },
        //         [PropertyFilterType.Other]: {
        //           ...state.filtersSelection[PropertyFilterType.Other],
        //           isChecked: !isObjectNullish({
        //             ...action.data.data.filters[PropertyFilterType.Other],
        //           }),
        //           data: {
        //             ...state.filtersSelection[PropertyFilterType.Other].data,
        //             ...action.data.data.filters[PropertyFilterType.Other],
        //           },
        //         },
        //       },
        //     }
        //   : {}),
      };
    case Types.SET_CATEGORY:
      return {
        ...state,
        category: {
          ...state.category,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_PUBLISHED:
      return {
        ...state,
        published: action.data ?? 2,
      };
    case Types.SET_FILTERS_SELECTION:
      return {
        ...state,
        filtersSelection: {
          ...action.data,
          fetch: true,
        },
      };
    case Types.INSERT_PRODUCT_FILTER:
      return {
        ...state,
        insertProductFilter: {
          ...state.insertProductFilter,
          status: action.status || null,
        },
      };
    case Types.SAVE_SEARCH:
      return {
        ...state,
        saveSearch: {
          ...state.saveSearch,
          status: action.status || null,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default ReportingListReducer;
